module.exports = __webpack_public_path__ + "static/media/WBN_GOLD.78cb0d3d.svg";